import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropFertilizersMinerals, setFootprintingCropFertilizersMineralsAdmin } from "services";

import { footprintingCropPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_CROP_FERTILIZERS_MINERAL } from "consts";

import { FootprintingCropFertilizer } from "models";

export const useMutateFootprintingCropFertilizersMinerals = (
  farmId: string,
  cropId: string,
  year: number,
  payload: FootprintingCropFertilizer[],
  primaryDataId: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingCropFertilizersMineralsAdmin : setFootprintingCropFertilizersMinerals;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_FERTILIZERS_MINERAL, primaryDataId, isAdmin],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_CROP_FERTILIZERS_MINERAL, primaryDataId, isAdmin],
          ...footprintingCropPrimaryQueryKeys(primaryDataId, farmId, cropId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
